var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 5.75H21.75C22.1478 5.75 22.5294 5.64464 22.8107 5.45711C23.092 5.26957 23.25 5.01522 23.25 4.75C23.25 4.48478 23.092 4.23043 22.8107 4.04289C22.5294 3.85536 22.1478 3.75 21.75 3.75H2.25C1.85218 3.75 1.47064 3.85536 1.18934 4.04289C0.908035 4.23043 0.75 4.48478 0.75 4.75C0.75 5.01522 0.908035 5.26957 1.18934 5.45711C1.47064 5.64464 1.85218 5.75 2.25 5.75Z",
    fill: "#083844"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 10.5H2.25C1.85218 10.5 1.47064 10.6054 1.18934 10.7929C0.908035 10.9804 0.75 11.2348 0.75 11.5C0.75 11.7652 0.908035 12.0196 1.18934 12.2071C1.47064 12.3946 1.85218 12.5 2.25 12.5H21.75C22.1478 12.5 22.5294 12.3946 22.8107 12.2071C23.092 12.0196 23.25 11.7652 23.25 11.5C23.25 11.2348 23.092 10.9804 22.8107 10.7929C22.5294 10.6054 22.1478 10.5 21.75 10.5Z",
    fill: "#083844"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 17.25H2.25C1.85218 17.25 1.47064 17.3554 1.18934 17.5429C0.908035 17.7304 0.75 17.9848 0.75 18.25C0.75 18.5152 0.908035 18.7696 1.18934 18.9571C1.47064 19.1446 1.85218 19.25 2.25 19.25H21.75C22.1478 19.25 22.5294 19.1446 22.8107 18.9571C23.092 18.7696 23.25 18.5152 23.25 18.25C23.25 17.9848 23.092 17.7304 22.8107 17.5429C22.5294 17.3554 22.1478 17.25 21.75 17.25Z",
    fill: "#083844"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.c92a4d486854d56cca007baf9c7f7049.svg";
export { ForwardRef as ReactComponent };